<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import FloatingCall from '@/components/layout/FloatingCall.vue'
import CookieConsent from '@/components/CookieConsent.vue'
import { localBusinessLd } from '@/lib/seo'
import { settings } from '@/content'
import { isProPath } from '@/lib/section'

const route = useRoute()
const isPro = computed(() => isProPath(route.path))

// Google Consent Mode v2 : tout est refuse par defaut, avant tout chargement GA.
const consentDefault = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied',wait_for_update:500});`

useHead({
  htmlAttrs: { lang: 'fr' },
  titleTemplate: (t?: string) =>
    t && !t.includes(settings.site_name) ? `${t}` : t || settings.site_name,
  script: [
    { children: consentDefault },
    localBusinessLd(),
  ],
})
</script>

<template>
  <a href="#contenu" class="visually-hidden">Aller au contenu</a>
  <AppHeader />
  <main id="contenu" :class="{ 'is-pro': isPro }">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </main>
  <AppFooter />
  <FloatingCall />
  <CookieConsent />
</template>

<style scoped>
/* Section PRO : la zone de contenu passe en charbon (theme sombre), meme dans
   les interstices entre les bandes de la page service. */
main.is-pro {
  background: #272a23;
}
</style>
